export default __webpack_public_path__ + "static/media/search.aa0c7c09.svg";